export default __webpack_public_path__ + "static/Trailer-Dumpsters-44b1589ad238c0f94360b8fe34af41a8.jpg";